import { render, staticRenderFns } from "./BlogOverview.vue?vue&type=template&id=21851b1f&scoped=true"
import script from "./BlogOverview.vue?vue&type=script&lang=js"
export * from "./BlogOverview.vue?vue&type=script&lang=js"
import style0 from "./BlogOverview.vue?vue&type=style&index=0&id=21851b1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21851b1f",
  null
  
)

export default component.exports